import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';
import KasittelyMob from './KasittelyMob.js';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';



let uhkvideo = [];


uhkvideo.push( <video key="strvideo" id="uhkvideoelementforplayback" width="auto" height="450vh" autoPlay="true" muted="true" mute="true" playsInline="true" loop="true" disablePictureInPicture="true" onCanPlay={uhkCanPlay} src={window.KASITTELYTEKSTIT.kolmasosiovideo} type="video/mp4" /> );

function uhkCanPlay(e)
{
	//console.log(e);
	//console.log("I can now play in Uhk");
	window.kasittelyVideoCanPlay = true;
}

let videoPlaying = false;

function sectionCallback()
{
	/*
	console.log("Play video");
	if (kasittelyVideoCanPlay)
		if (!videoPlaying) document.getElementById("uhkvideoelementforplayback").play();
	window.SECTIONCALLBACKS = [];
	*/
}

let firstUhkLoad = true;

let stopupdates = function () {};

function Kasittely(p)
{
	window.SECTIONCALLBACKS = [];
	React.useEffect( () => { if ( window.RECENTLOAD )  window.drawKasittely() } );
	let [progress, pupdate] = React.useState(0);
	let [progressLp, pupdateLp] = React.useState(0);
	let [nomoreload, nomoreupdate] = React.useState(<div></div>);

	stopupdates = nomoreupdate;

	if (! (window.KAIKKIKASITTELYKUVATLADATTU && window.kasittelyVideoCanPlay) )
	{
		function loopy()
		{
			if (! (window.KAIKKIKASITTELYKUVATLADATTU && window.kasittelyVideoCanPlay) )
			{
				setTimeout(loopy, 500);
			}
			else
			{
				let empty = [];
				stopupdates(empty);
			}
			pupdate((window.allmedia.kasittely.length + window.allmedia.kasittelyv.length) + " images out of " + window.allmedia.kasittelys );
			let addition = 0;
			if (window.kasittelyVideoCanPlay) addition = 10;
			pupdateLp((90 * (window.allmedia.kasittely.length/window.allmedia.kasittelys)) + addition);
		}
		setTimeout(loopy, 1000);
		let cont = [];
		if (firstUhkLoad) firstUhkLoad = false;
		else cont = uhkvideo;
		return(	<div><ThemeProvider theme={window.MUIthemeWhite}>
			<div className="keskitetty" style={{color: "#000000", fontSize: "125%"}}>
				<div>Ladataan:</div>
				<div>
    	  				<LinearProgress variant="determinate" value={progressLp} />
				</div>
			</div></ThemeProvider><div style={{ display:"none" }}> {cont} {nomoreload} </div> </div>);
	}
	else
	{
		if (isMobile && window.NOTIPAD)
		{
			return (<KasittelyMob uhkvideo={uhkvideo}/>);
		}
		else
		{

			//let vsrc = window.allmedia.kasittelyv[0].src;
			window.SECTIONCALLBACKS.push(sectionCallback);
			return (<div style={{color: "#000000", fontSize: "125%"}}>
			<div key="uhkisosioeka" className="kuvallinenvasen">
				<div>
					<h1>{window.KASITTELYTEKSTIT.ekaosio}</h1>
					<div key="gapihmomia" className="otsikkogap"></div>
					{window.KASITTELYTEKSTIT.ekaosioekar}
					<div key="gapihmomib" className="paragap"></div>
					{window.KASITTELYTEKSTIT.ekaosiotokar}
				</div>
				<div></div><div></div>
			</div>
			<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
			<div key="gapihmomic" className="osiogap"></div>
			<div key="uhkisosiotoka" className="kuvallinenoikeavasmargi">
				<div>
					<img height="300vh" src={window.KASITTELYTEKSTIT.tokaosiokuva} /><br/>
					{window.KASITTELYTEKSTIT.tokaosiokuvateksti}
				</div>
				<div></div>
				<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
					<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
						<h3>{window.KASITTELYTEKSTIT.tokaosioekar}</h3>
						<div key="gapihmomid" className="osiogap"></div>
						<div>{window.KASITTELYTEKSTIT.tokaosiotokar}</div>
					</div>
				</div>
			</div>
			<div key="gapihmomie" className="osiogap"></div>
			<div key="uhkisosioekaa" className="kuvallinenvasen">
				<div>
					{window.KASITTELYTEKSTIT.kolmasosio}
				</div>
				<div></div>
			</div>
			<section id="uhkvideosection"></section>
			<div key="gapihmomif" className="osiogap"></div>


			<div key="uhkisosiotokaa" className="kuvallinenoikeavasmargi">
				<div style={{position: "absolute", clipPath: "polygon(16% 7%, 16% 100%, 92% 100%, 92% 7%)" }}>
					{uhkvideo}
					</div>
					<div style={{position: "absolute"}}>
						<img height="500vh" src={window.KASITTELYTEKSTIT.kolmasosiokuva} />
					</div>
				<div>
				</div>
				<div></div>
				<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
					<div style={{height:"10vh"}}></div>

					<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
						<div>{window.KASITTELYTEKSTIT.kolmasosioekar}</div>
						<div key="gapihmomig" className="osiogap"></div>
						<h3>{window.KASITTELYTEKSTIT.kolmasosiotokar}</h3>
					</div>
				</div>
			</div>

			<div key="gapihmomih" className="osiogap"></div>
			<div key="gapihmomiha" className="osiogap"></div>
			<div key="gapihmomihb" className="osiogap"></div>
			<div key="gapihmomihc" className="osiogap"></div>
			<div key="gapihmomihd" className="osiogap"></div>
			<div key="gapihmomihe" className="osiogap"></div>
			<div className="vasen" style={{fontSize:"0.5em"}}>
					{window.KASITTELYTEKSTIT.sivunalateksti}
			</div>


			<div className="seuraavasivu">
				<div className="seuraavasivuotsikko" >
					<Link to="../video" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToVideo}>
						<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>VIDEO</span>
					</Link>
				</div>
				<div style={{transform: "scale(0.75)"}}>
					<Link to="../video" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToVideo}>
						<ArrowRight stroke="#000000"/>
					</Link>
				</div>
			</div>

		</div>);
		}
	}
}
function moveToVideo()
{
	window.SETVIDEO();
	window.drawVideo();
}


export default Kasittely;
